import { UserModel } from 'components/Modals/types'
import { CategoryTypes } from './category'
import getConfig from 'next/config'

export type ServiceApiType = 'APPOINTMENT' | 'GROUP' | 'SERIES'
const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

export enum ServiceApiTypeEnum {
    APPOINTMENT = "APPOINTMENT",
    GROUP = "GROUP",
    SERIES = "SERIES"
}

export enum ServiceMemberPriceType {
    DISCOUNTED_PRICE = "DISCOUNTED_PRICE",
    DISCOUNT_PERCENTAGE = "DISCOUNT_PERCENTAGE",
    CREDITS = "CREDITS",
}

export enum ServiceType {
    APPOINTMENT = 'Appointment',
    GROUP = 'Group Class',
    SERIES = 'Series',
}

export const ServiceDisplay = [
    {active: '/images/ico-active-service-appt.svg', selected: '/images/ico-selected-service-appt.svg', translation: "common.appointment_desc"},
    {active: '/images/ico-active-service-group.svg', selected: '/images/ico-selected-service-group.svg', translation: "common.group_desc"},
    {active: '/images/ico-active-service-series.svg', selected: '/images/ico-selected-service-series.svg', translation: "common.series_desc"}
]

export type ServiceDiscountType = { //Maybe convert to a generic and use in a generic selector with image 
    active: string
    inactive: string,
    translation: string,
    value: any
}

export const ServiceDiscountTypes : ServiceDiscountType[] = [
    {active: 'https://static.aot.plus/images/ico-member-dollar-selected.svg', inactive: 'https://static.aot.plus/images/ico-member-dollar-active.svg', translation: "services.member_price_type_discounted_price", value: ServiceMemberPriceType.DISCOUNTED_PRICE},
    {active: 'https://static.aot.plus/images/ico-member-percent-selected.svg', inactive: 'https://static.aot.plus/images/ico-member-percent-active.svg', translation: "services.member_price_type_discount_percentage", value: ServiceMemberPriceType.DISCOUNT_PERCENTAGE},
    {active: 'https://static.aot.plus/images/ico-member-credits-selected.svg', inactive: 'https://static.aot.plus/images/ico-member-credits.svg', translation: "services.member_price_type_credits", value: ServiceMemberPriceType.CREDITS},
]

export type ServiceApiItem = {
    id: string,
    deletedAt?: string,
    accentColorHex?: string,
    primaryColorHex: string,
    secondaryColorHex?: string,
    duration: number,
    addons?: string[],
    blockTimeAfter?: number,
    blockTimeBefore?: number,
    public: boolean,
    category: {
        id: string,
        name?: string,
        type: CategoryTypes,
    },
    name: string,
    tenant: {
        id: string,
    },
    staff: {
        id: string,
        user: UserModel,
    }[],
    price: number,
    maxCapacity: number,
    description: string,
    longDescription?: string,
    customSlug?: string,
    imageUrl?: string,
    type: ServiceApiType,
    series: boolean | false,
    memberPrice?: number,
    memberPriceType?: ServiceMemberPriceType,
    preventDuplicateBookingByEmail?: boolean | false,
    preventDuplicateBookingByPhone?: boolean | false
}

export interface ServiceBase {
    accent_color?: string,
    primary_color?: string,
    secondary_color?: string,
    duration?: number,
    is_public: boolean,
    blocked_from?: number,
    blocked_to?: number,
    name: string,
    price: number,
    max_participants?: number,
    description?: string,
    long_description?: string,
    service_type: string,
    slug?: string,
    image_url?: string,
}

export interface ServiceFormModel extends ServiceBase {
    id?: string,
    category: {
        id: string,
        name?: string,
    },
}

export interface ServiceItem extends ServiceBase {
    id: string,
    addons?: string[],
    is_public: boolean,
    description: string,
    category: {
        id: string,
        name?: string,
    },
    staff: {
        id: string,
        user_id: string,
        first_name: string,
        last_name: string,
        staff_image?: string
    }[],
    memberships?: Record<string, string>[],
    service_type: string,
    member_price?: number,
    member_price_type?: ServiceMemberPriceType
    prevent_duplicate_booking_by_email?: boolean
    prevent_duplicate_booking_by_phone?: boolean
    is_archived?: boolean
}

